import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { Colors } from '~/styles'
import { ConvertLocalTimeGet } from '~/utils'

import Styled from '../../final-transshipment.styled'

const ReportTableBody = ({ data, gearlessColumns }) => {
  const { Location } = useSelector((state) => state.usersProfileReducer)

  return (
    <Styled.Tbody>
      {(data || []).map((row, idx) => (
        <Styled.Tr
          key={idx}
          index={idx}
          height='58px'
          backgroundColor={idx % 2 === 0 ? Colors.white : Colors.lightAsh}
        >
          <Styled.Td>{idx + 1}</Styled.Td>
          <Styled.Td fontWeight='700'>{row.vessel_name || '-'}</Styled.Td>
          <Styled.Td>{row.buyer || '-'}</Styled.Td>
          <Styled.Td>{row.sr_no || '-'}</Styled.Td>
          <Styled.Td>{row.geared || '-'}</Styled.Td>
          <Styled.Td>{row.ratu_giok || '-'}</Styled.Td>
          {/* Gearless Columns */}
          {gearlessColumns.length > 0 && gearlessColumns.map((col, i) => {
            // If gearless is null, return a placeholder
            if (_.isNull(row.gearless)) {
              return <Styled.Td key={`gearless-${col}-${i}`}>-</Styled.Td>
            } else {
              const match = row.gearless.find((g) => g.unit_name === col)
              return <Styled.Td key={`gearless-${col}-${i}`}>{match ? match.value : '-'}</Styled.Td>
            }
          })}
          <Styled.Td>{row.total_gearless || '-'}</Styled.Td>
          <Styled.Td>{row.bl_qty || '-'}</Styled.Td>
          <Styled.Td>{ConvertLocalTimeGet(Location.LocationDescription, row.bl_date, 'DD MMM YYYY') || '-'}</Styled.Td>
        </Styled.Tr>
      ))}
    </Styled.Tbody>
  )
}

ReportTableBody.propTypes = {
  data: PropTypes.array.isRequired,
  gearlessColumns: PropTypes.array.isRequired,
}

export default ReportTableBody